import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { Checkbox } from "shared/checkboxes"

const TITLE = "Track Submissions"

const FormTracksSubmissionsSetting = ({
  formRequiresAuthentication,
  formTracksSubmissions,
  updateFormTracksSubmissions,
}) => (
  <div className="pr-16">
    <div className="flex mb-2">
      <label className={clsx(
        "font-bold text-sm",
        !formRequiresAuthentication && "text-gray",
      )}
      >
        <Checkbox
          className="mr-2"
          value={formTracksSubmissions}
          onChange={updateFormTracksSubmissions}
          disabled={!formRequiresAuthentication}
        />
        {TITLE}
      </label>
    </div>
    <div className="text-sm/6 text-dark">
      Tracked submissions will identify the user submitting the form. Do not track submissions if a user should remain anonymous.
    </div>
  </div>
)

FormTracksSubmissionsSetting.propTypes = {
  formRequiresAuthentication: types.bool.isRequired,
  formTracksSubmissions: types.bool.isRequired,
  updateFormTracksSubmissions: types.func.isRequired,
}

export default FormTracksSubmissionsSetting
